var render = function render(){var _vm=this,_c=_vm._self._c;return _c('initUserId',{attrs:{"image":'https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/expoApplent/signPage.png'}})
}
var staticRenderFns = []

export { render, staticRenderFns }